import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, avatarUrl } from '../api.js';
import { useGuild } from './GuildLayout.jsx';

export default function Members() {
  const { guildId } = useGuild();
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');

  useEffect(() => {
    api.members(guildId, '?limit=1000').then(d => { setMembers(d.members); setLoading(false); });
  }, [guildId]);

  const filtered = filter
    ? members.filter(m =>
        (m.username || '').toLowerCase().includes(filter.toLowerCase()) ||
        (m.global_name || '').toLowerCase().includes(filter.toLowerCase()) ||
        (m.nick || '').toLowerCase().includes(filter.toLowerCase()) ||
        m.id.includes(filter))
    : members;

  if (loading) return <div className="empty">Loading members…</div>;

  return (
    <>
      <h1>Members</h1>
      <p className="subtitle">{members.length} fetched.</p>
      <div className="field">
        <input placeholder="Filter by name, nickname, or ID…" value={filter} onChange={e => setFilter(e.target.value)} />
      </div>
      <div className="card" style={{ padding: 0 }}>
        <table className="table">
          <thead>
            <tr><th></th><th>Name</th><th>Nickname</th><th>Joined</th><th>Status</th></tr>
          </thead>
          <tbody>
            {filtered.map(m => (
              <tr key={m.id}>
                <td style={{ width: 48 }}><img className="avatar" src={avatarUrl(m)} alt="" /></td>
                <td>
                  <Link to={`/g/${guildId}/users/${m.id}`}>
                    {m.global_name || m.username}
                    {m.bot && <span className="badge" style={{ marginLeft: 6 }}>bot</span>}
                  </Link>
                  <div className="dim" style={{ fontSize: 12 }}>{m.username}</div>
                </td>
                <td>{m.nick || <span className="dim">—</span>}</td>
                <td>{m.joined_at ? new Date(m.joined_at).toLocaleDateString() : <span className="dim">—</span>}</td>
                <td>
                  {m.communication_disabled_until && new Date(m.communication_disabled_until) > new Date()
                    ? <span className="badge warn">timed out</span>
                    : <span className="badge success">active</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
